import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=76e274a6&scoped=true&"
import script from "./NotificationPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e274a6",
  null
  
)

export default component.exports